import common from '@/store/common/mutations';
import * as types from './mutation-types';
import { SEARCH_PARAMS, PAGING_INFO, SELECTED_ROW } from './state';

export default {
	...common,
	[types.STATE_INIT]: state => {
		state.powTourPrvsMngManagements = [];
		state.excelDownLoadList = []; //엑셀다운로드시 해더저장

		/** selectbox */
		state.occuPlCdList = []; //form 에서 사용하는 발생공정 코드목록
		state.allPowPrvsCdList = []; //form 에서 사용하는 라인 총 코드목록
		state.powPrvsCdList = []; //form 에서 사용하는 라인 코드목록
		state.insnWayCdList = []; //form 에서 사용하는 방식 코드목록
		state.insnCyclCdList = []; //form 에서 사용하는 주기 코드목록
		state.useYnCdList = []; //form 에서 사용하는 사용여부 코드목록

		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.selectedRow = SELECTED_ROW();
		state.oldSelectedRow = SELECTED_ROW();

		state.isOldRow = '';
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.SELECTED_ROW]: (state, { key, value }) => {
		state.selectedRow[key] = value;
	},
	[types.SELECTED_ROW_INIT]: state => {
		state.selectedRow = SELECTED_ROW();
	}
};
